import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
    pt: {
        label: {
            acronym: "Sigla",
            action: "Ação",
            active: "Ativo",
            addApprover: "Adicionar aprovador",
            addContractItem: "Adicionar cesta",
            addStep: "Adicionar tipo aprovador",
            admin: "Administração",
            prodam: "PRODAM",
            approval: "Aprovação",
            approvalCycle: "Sequência de aprovação",
            approvalDateF: "Aprovada em",
            approvalDetails: "Detalhes da aprovação",
            approve: "Aprovar",
            approved: "Aprovado",
            approvers: "Aprovadores",
            approverType: "Tipo do aprovador",
            area: "Área",
            audit: "Auditoria",
            auditSession: "Sessão de auditoria",
            basicInfo: "Informações Básicas",
            cancel: "Cancelar",
            cancelDemand: "Cancelar demanda",
            clear: "Limpar",
            clearSubstitute: "Remover substituto",
            close: "Fechar",
            closure: "Encerramento",
            code: "Código",
            comments: "Comentários",
            comment: "Comentário",
            configuration: "Configuração",
            confirmPassword: "Confirmar senha",
            contract: "Contrato",
            contractItem: "Cesta",
            contractNumber: "Número do contrato",
            contractObject: "Objeto",
            contractCopy: "Copiar contrato",
            contractUpdate: "Migrar demandas",
            contractor: "Relacionamento",
            contractorManager: "Gerente Relacionamento",
            contracts: "Contratos",
            controlAccess: "Controla Acesso",
            createArea: "Criar área",
            createContract: "Criar contrato",
            createDemand: "Criar demanda",
            createDemandOwnerSubstitutions: "Criar substituição",
            createOffice: "Criar secretaria",
            createSystem: "Criar sistema",
            createTypeDemand: "Criar tipo de demanda",
            createTypeApprover: "Criar tipo de aprovador",
            creator: "Criador",
            currentPassword: "Senha atual",
            date: "Data",
            dateApproved: "Data aprovação",
            dateRejected: "Data rejeição",
            days: "dias",
            dashboard: "Painel",
            deliverablesAmount: "Quantidade de entregas",
            delivery: "Entrega",
            deliveryDate: "Data de entrega",
            deliveryTime: "Prazo estimado (Dias úteis)",
            estimatedDeliveryDate: "Data Estimada de Entrega",
            demand: "Demanda",
            demands: "Demandas",
            demandType: "Tipo de Demanda",
            description: "Descrição",
            desirableDate: "Data desejável",
            details: "Detalhes",
            editPerson: "Editar usuário",
            email: "Email",
            endDate: "Data de termino",
            enter: "Entrar",
            estimatedQuantity: "Quantidade orçada",
            estimatedTime: "Horas previstas",
            events: "Eventos",
            execute: "Executar",
            executedQuantity: "Quantidade executada",
            export: "Exportar",
            exit: "Sair",
            files: "Arquivos",
            filesDescription: "Descrição",
            filters: "Filtros",
            flow: "Tipo de demanda",
            from: "De",
            demandTypes: "Tipos de demanda",
            hired: "Prodam",
            hiredAmount: "Quantidade contratada",
            inactive: "Inativo",
            inactivate: "Desativar",
            isAdmin: "Administrador",
            isOutsourced: "Terceiro",
            lifeCycle: "Ciclo de vida",
            message: "Mensagem",
            name: "Nome",
            newUser: "Registrar usuário",
            newPassword: "Nova senha",
            number: "Número",
            office: "Secretaria",
            originalOwner: "Responsável",
            outcome: "Resultado",
            owner: "Responsável atual",
            pagination: "Registros por página",
            password: "Senha do Domínio",
            person: "Usuário",
            persons: "Usuários",
            planning: "Planejamento",
            profile: "Perfil",
            reason: "Justificativa",
            receivedDate: "Data de Chegada",
            reference: "Referência",
            reload: "Recarregar",
            reject: "Devolver",
            relatedDemand: "Demanda vinculada",
            remarks: "Observações",
            remove: "Remover",
            report: "Relatório",
            request: "Solicitação",
            requestApproval: "Enviar para aprovação",
            requester: "Solicitante",
            requestPersonUpdate: "Atualiza perfil",
            restart: "Reiniciar",
            save: "Salvar",
            saveDemand: "Salvar demanda",
            search: "Pesquisar",
            similarDemandsDescription: "Demandas similares",
            startDate: "Data de início",
            status: "Situação",
            substitute: "Substituto",
            substitutes: "Substituições",
            substitutions: "Substituições",
            switchUser: "Trocar de usuário",
            system: "Sistema",
            supplier: "Fornecedor",
            systems: "Sistemas",
            title: "Título",
            to: "Até",
            token: "Dados de Autorização",
            types: "Tipos",
            unit: "Unidade de medida",
            unitCost: "Valor unitário",
            usedTime: "Horas executadas",
            user: "Usuário",
            validity: "Validade",
            warranty: "Prazo de garantia",
            warrantyValidity: "Validade da garantia",
            workflowHistory: "Histórico desta etapa",
            yourApproval: "Sua aprovação",
            yourCancel: "Seu cancelamento",
            yes: "Sim",
            no: "Não",
            averageEvaluationDemands: "Avaliação",
            demandEvaluation: "Avaliação da Demanda",
            notEvaluatedDemands: "Demandas",
            evaluatedDemands: "Avaliadas",
            dateStartEvaluationDemand: "Data",
            allowsEvaluation: "Permite Avaliação",
            evaluationStartDate: "Data de Início Avaliação",
            houveDevolucoes: "Demandas com Devolução",
            dtImplementacao: "Fim Garantia",
            implantacao: "Implantação",
            garantia: "Garantia",
        },

        message: {
            error: {
                approvalDateRequired:
                    "Informe a data em que a demanda foi aprovada",
                areaRequired: "Informe a area",
                attachmentsEmpty: "O arquivo selecionado está vazio",
                attachmentsQuantity: "O limite permitido são 5 arquivos",
                attachmentsSize: "O limite permitido são 5MB por arquivo",
                cac:
                    "Falha ao comunicar com o CAC. Tente novamente mais tarde.",
                contractRequired: "Informe o contrato",
                contractNewRequired: "Informe o novo contrato",
                contractNewItemRequired:
                    "Informe pelo menos 1 item para ser atualizado",
                credentials: "O usuário ou senha informados são inválidos.",
                deliveryDateRequired: "Informe a data de entrega",
                descriptionRequired: "Informe a descrição",
                emailAddressInvalid: "Informe um email válido",
                emailAddressRequired: "Informe o email",
                emptyFinishDate: "A data final deve ser preenchida",
                emptyStartDate: "A data inicial deve ser preenchida",
                estimatedQuantityRequired: "Informe a quantidade orçada",
                executedTimeRequired: "Informe a quantidade executada",
                fatalError:
                    "Um erro inesperado aconteceu. Por favor entre em contato com a PRODAM.",
                flowRequired: "Informe o fluxo de aprovação",
                formError: "Seu formulário contém erros",
                networkError:
                    "Erro de comunicação com o servidor. Por favor tente novamente mais tarde.",
                noPermission: "Você não tem permissão para acessar esta página",
                officeRequired: "Informe a secretaria",
                outsourcedAdmin:
                    "Usuário terceirizado não pode ser administrador.",
                passwordRequired: "Informe sua senha",
                passwordNoMatch: "As senhas não conferem",
                passwordTooSmall: "A senha deve ter 6 ou mais caracteres",
                period: "A data de término deve ser posterior a data de início",
                plannedTimeRequired: "Informe a quantidade orçada",
                required: "Obrigatório",
                requesterRequired: "Informe o solicitante",
                server: "Falha ao buscar os dados. Tenta novamente mais tarde.",
                systemRequired: "Informe o sistema",
                titleRequired: "Informe o titulo",
                userRequired: "Informe seu usuário",
                validityFinish:
                    "A data final da garantia deve ser posterior a data inicial",
                validityStart:
                    "A data de início da garantia deve ser posterior ou igual a data de validade"
            },
            info: {
                approverType:
                    "Tipos de aprovadores são usados em tipos de demanda para determinar as aprovações necessárias em cada situação do ciclo de vida da demanda. O usuário que será responsável pela aprovação é determinado pelo sistema a qual a demanda pertence.",
                approverTypeInactive:
                    "Este tipo de aprovador está inativo. Ele não pode ser modificado.",
                approverTypeInUse:
                    "Um ou mais sistemas e/ou tipos de demanda usam este tipo de aprovador.",
                contractInactive:
                    "Este contrato está inativo. Ele não pode ser modificado.",
                contractInUse:
                    "Uma ou mais demandas ativas e/ou sistemas usam este contrato. Os itens da cesta em uso não podem ser inativados.",
                contractItems:
                    "Informe o nome e a quantidade de {unit} disponível em cada um dos itens da cesta.",
                demandCancelRequest:
                    "Insira um motivo para o cancelamento da demanda. Essa ação é definitiva e irreversível.",
                demandCreationApproval:
                    "Revise os dados da demanda e os comentários inseridos pelos aprovadores anteriores (se houver) antes de aprovar sua necessidade ou devolver a demanda.",
                demandCreationDetails:
                    "Informe o objetivo da demanda e se haverá criação, alteração ou exclusão de funcionalidades do sistema (descrição), quais precauções devem ser tomadas (observação), qual problema a demanda irá resolver (justificativa) e qual o resultado esperado após sua execução (resultado). Se esta for uma demanda regular &mdash; como geração de relatórios &mdash; informe os números das demandas anteriores que trataram do mesmo assunto (demandas similares).",
                demandCreationLifeCycle:
                    "Os dados abaixo são controlados pelo sistema e não podem ser alterados.",
                demandCreationSentForApproval:
                    "Solicitação enviada para aprovação",
                demandDeliveryApproval:
                    "Revise a entrega, fazendos as verificações necessárias, e os comentários inseridos pelos aprovadores anteriores (se houver) antes de aprovar ou devolver esta demanda.",
                demandDeliveryDetails:
                    "Informe a localização e dados de acesso do entregável (no caso do desenvolvimento, evolução ou manutenção de um sistema) ou quais arquivos correspondem as evidências (no caso de demandas que não são facilmente verificáveis).",
                demandDeliverySentForApproval: "Entrega enviada para aprovação",
                demandFiles: "Indique como cada arquivo deve ser usado.",
                demandFinalizing:
                    "Esta demanda foi executada e será encerrada. Por favor indique que você está ciente.",
                demandNotFound: "Demanda não encontrada",
                demandPlanningApproval:
                    "Revise as informações de planejamento da demanda e os comentários inseridos pelos aprovadores anteriores (se houver) antes de ratificar sua necessidade ou devolver a demanda.",
                demandPlanningBasicInfo:
                    "Informe o tempo que será necessário para executar a demanda e em quantos dias úteis ela será finalizada.",
                demandPlanningDetails:
                    "Descreva as atividade que serão executadas na demanda e indique o tempo necessário para cada uma. Caso o campo abaixo não seja o suficiente, clique no botão 'Anexar arquivos' para anexar os documentos necessários.",
                demandPlanningSentForApproval:
                    "Planejamento enviado para aprovação",
                demandSaved: "Demanda D{code} salva.",
                demandSearch:
                    "Busque demandas ativas, ou encerradas a até 30 dias, por qualquer coluna da tabela abaixo",
                demandSearchNumber: "Digite o número da demanda e aperte enter",
                demandTypeApprovers:
                    "Informe os tipos de aprovadores necessários em cada situação, assim como sua alçada. A ordem que os tipos de aprovadores aparecem em cada situação será a ordem em que eles devem realizar a aprovação.",
                demandTypeInactive:
                    "Este tipo de demanda está inativo. Ele não pode ser modificado.",
                demandTypeInUse:
                    "Uma ou mais demandas ativas usam este tipo de demanda. A sequência de aprovadores não pode ser alterada.",
                expireSubstitutes: "Esta rotina ",
                generalSearch:
                    "Busque por qualquer uma das colunas da tabela abaixo",
                notSavedF: "Não salva",
                person: "",
                personFirstLogin:
                    "Esta é a primeira vez que você acessa o GDS. Por favor preencha os campos abaixo para ter acesso ao sistema.",
                personUpdateRequired:
                    "Seu perfil está desatualizado. Por favor confira as informações abaixo e clique em salvar para ter acesso ao resto do sistema.",
                personSearch: "Busque por código ou nome",
                substitute:
                    "Informe qual usuário ficará responsável pelas demandas deste usuário. Durante o período de vigência apenas o substituto poderá aprovar as demandas deste usuário.",
                substitutes: "Este usuário substitui os usuários abaixo.",
                systemApprovers:
                    "Informe quais usuários podem aprovar demandas neste sistema e por qual tipo de aprovação eles são responsáveis.",
                systemInUse:
                    "Uma ou mais demandas ativas usam este sistema. Alterações no relacionamento Prodam ou lista de aprovadores podem levar a mudanças nos responsáveis por estas demandas.",
                substitutionInUse:
                    "Não é permitido alterar a demanda ou o responsável de uma substituição existente."
            },
            success: {
                contractRemoved: "Contrato removido com sucesso",
                demandApproved: "Demanda D{code} aprovada com sucesso",
                demandCanceled: "Demanda D{code} cancelada com sucesso",
                demandOwnerSubstitutionRemoved:
                    "Substituição removida com sucesso",
                demandRejected: "Demanda D{code} devolvida com sucesso",
                demandRequested: "Demanda D{code} enviada para aprovação",
                demandSaved: "Demanda D{code} salva com sucesso",
                systemRemoved: "Sistema removido com sucesso",
                approverTypeRemoved: "Tipo de aprovador removido com sucesso",
                demandTypeDisabled: "Tipo de demanda desabilitado com sucesso",
                demandTypeRemoved: "Tipo de demanda removido com sucesso",
                saved: "Dados salvos com sucesso",
                userSaved: "Dados salvos com sucesso",
                passwordUpdated: "Senha alterada com sucesso.",
                evaluationRemoved: "Avaliação removida com sucesso",
                evaluationSaved: "Avaliação salva com sucesso"
            },

            validation: {
                invalid: "Inválido",
                loginTooShort: "Informe pelo menos 7 caracteres",
                notZero: "Informe um valor maior do que 0 (zero)",
                numeric: "Informe um valor numérico",
                passwordTooShort: "Informe pelo menos 6 caracteres",
                required: "Obrigatório",
                tooShort: "Informe pelo menos 3 caracteres",
                unique: "Valor já informado"
            },

            warning: {
                noData: "Dados não encontrados",
                noDataWorkflowHistory:
                    "Nenhuma aprovação realizada até o momento"
            }
        },

        tooltip: {
            actions: "Ações",
            allFilters: "Todos os filtros",
            report: "Relatório",
            refresh: "Atualizar",
            remove: "Remover"
        },

        title: {
            approverType: "Tipo de Aprovador",
            demandType: "Tipo de Demanda",
            ownedDemands: "Demandas sob sua responsabilidade",
            createdDemands: "Demandas que você criou para outras pessoas",
            requestedDemands: "Demandas solicitadas por você",
            quickSearch: "Busca rápida"
        },

        type: {
            status: [
                "-",
                "Aberta",
                "Aprovação da solicitação",
                "Planejamento",
                "Aprovação do planejamento",
                "Em Execução",
                "Aprovação da entrega",
                "Encerramento",
                "Cancelada",
                "Encerrada"
            ],
            event: {
                approved: "Aprovado",
                rejected: "Rejeitado"
            },
            httpError: {
                400: "Erro de validação",
                404: "Não encontrado",
                403: "Proibido",
                500: "Erro fatal",
                501: "Ação não suportada",
                503: "Serviço indisponível"
            }
        }
    }
};

export default new VueI18n({
    locale: "pt",
    messages
});



// WEBPACK FOOTER //
// ./src/i18n/index.js